export default {
  namespaced: true,

  state: () => ({
    isLoading: false,
  }),

  getters: {
  },

  mutations: {},

  actions: {
    async uploadMedia({ commit }, data) {
      try {
        const url = '/v1/admin/upload/image'

        const formData = new FormData()
        formData.append('image', data)

        const response = await this._vm.$http.post(url, formData)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengunggah Gambar!',
        }, { root: true })
        return false
      }
    },
    async uploadVideo({ commit }, data) {
      try {
        const url = '/v1/upload/video'

        const formData = new FormData()
        formData.append('video', data)

        const response = await this._vm.$http.post(url, formData)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengunggah Video!',
        }, { root: true })
        return false
      }
    },
  },
}
